import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/classes/$classId')({
  component: ClassDetail,
});

function ClassDetail() {
  return <Outlet />;
}
